export const lineChartData = [
  { year: 2024, value: 10 },
  { year: 2025, value: 40 },
  { year: 2026, value: 63 },
  { year: 2027, value: 65 },
  { year: 2028, value: 70 },
  { year: 2029, value: 80 },
  { year: 2030, value: 120 },
];

export {};

export const barChartData = [
  { year: 2024, projects: 15 },
  { year: 2025, projects: 65 },
  { year: 2026, projects: 50 },
  { year: 2027, projects: 30 },
  { year: 2028, projects: 60 },
  { year: 2029, projects: 50 },
];

export {};
